import { InputTag } from 'mixs/base/input_mixin';
import Timelag from 'utilities/timelag';
export class SearchCheckbox extends InputTag {
  lag:Timelag;
  lastClickValue: string;
  public init() {
    super.init();
    this.lag = new Timelag(this.onTimeout, 300);
    this.updateChecked();
    this.update();
    this.watch();
  }
  onTimeout(){
    this.lastClickValue = null;
  }
  updateChecked(newValue = null){
    if(!newValue){ newValue = this.opts; };
    let value = newValue.value
    let ary = [];
    if(value != null && value != ''){
      ary = newValue.value.split(',');
    }
    for(let i=0;i<newValue.items.length;i++){
      let item = newValue.items[i];
      if(ary.length <= 0 || ary.includes(item['value'].toString())){
        item['checked'] = 'checked';
      } else {
        item['checked'] = null;
      }
    }
  }
  public onChange(e){
    let ary = []
    if(this.lastClickValue == e.target.value){
      ary = [e.target.value];
    }else{
      this.lastClickValue = e.target.value;
      this.lag.start();
      ary = this.getArrayFromCheckboxes();
    }
    this.dispatch({value: ary.join(',')})
  }
  getArrayFromCheckboxes(){
    let ary = []
    let checkboxes:NodeList = this.querySelectorAll('input[type="checkbox"]');
    for(let i=0; i<checkboxes.length; i++){
      let checkbox:HTMLInputElement = checkboxes[i] as HTMLInputElement;
      if(checkbox.checked){ ary.push(checkbox.value); }
    }
    if(ary.length >= this.opts.items.length){ ary = []; }
    return ary;
  }
  onChangeStore(a,b,c){
    this.updateChecked(a);
    super.onChangeStore(a,b,c)
  }
}
riot.mixin('inputs.search.checkbox', SearchCheckbox as riot.TagMixin)
